"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListenToKeyDown = void 0;
var _react = require("react");
var _useGlobalEvents = require("./useGlobalEvents");
const useListenToKeyDown = (keyNames, action) => {
  const events = (0, _react.useMemo)(() => [{
    name: 'keydown',
    listener: event => {
      if (keyNames.includes(event.key)) {
        action();
      }
    }
  }], [keyNames, action]);
  (0, _useGlobalEvents.useGlobalEvents)(events);
};
exports.useListenToKeyDown = useListenToKeyDown;
//# sourceMappingURL=useListenToKeyDown.js.map